import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/Dropdown'
import '../../css/common/PhoneInput.css';
import { DropdownMenu } from '../../components';

import united_states_flag  from '../../assets/flags/united_states.png';
import united_kingdom_flag from '../../assets/flags/united_kingdom.png';
import mexico_flag from '../../assets/flags/mexico.png';
import canada_flag from '../../assets/flags/canada.png';

class PhoneInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_country: 'united_states',
      remove_border_radius: false,
      last_length_count: 0,
      in_focus: false,
    }
  }

  render() {

    var value    = this.props.value || '';
    var onChange = this.props.onChange;
    var style    = this.props.style;
    let invalid  = this.props.invalid || false;

    let container_style = this.props.containerStyle || {};
    let formatted_value = this.getFormattedDisplayValue(value);
    let border_color    = this.state.in_focus ? '#1dc2ff' : '#e7e7e7';
        border_color    = invalid ? '#F71735' : border_color;
    let placeholder     = this.props.placeholder || 'Phone Number';



    return<div className={ `flex-container-row phone-input-container` } style={{ borderColor: border_color, ...container_style }}>
      { this.renderCountryDropdown() }
      <input  type='text'
              className='phone-input-input'
              style={style}
              placeholder={placeholder}
              value={formatted_value}
              onFocus={ () => { this.setState({ ...this.state, in_focus: true  }) }}
              onBlur={  () => { this.setState({ ...this.state, in_focus: false }) }}
              onChange={ (event) => {
                let input_text = event.target.value;
                let no_code    = this.getWithoutCode(input_text);
                let clean_numbers_only = this.getNumbersOnly(no_code);
                let added_country_code = this.getAddCode(clean_numbers_only);
                let final_input_value  = added_country_code;

                final_input_value      = this.state.selected_country !== 'united_states' ? input_text : final_input_value;

                onChange(final_input_value);
              }}
            />

    </div>
  }

  getFormattedDisplayValue = (text) => {
    let str     = text || '';
    let no_code = this.getWithoutCode(str);
    let clean_numbers_only = this.getNumbersOnly(no_code);
    let appropriate_format = this.getFormattedNumber(clean_numbers_only);
    let final_value        = this.state.selected_country === 'united_states' ? appropriate_format: str;
    return final_value;
  }

  getWithoutCode = (text) => {
    let str      = text || '';
    let has_code = str && str.length > 2 && str[0] && str[1] && str[0] === '+' && str[1] === '1' ? true : false;
    let cleaned  = str;

    if (has_code) {
      cleaned  = str.substring(2);
    }

    if (str.length === 2 && has_code) {
      cleaned = '';
    }

    return cleaned;
  }

  getAddCode = (num_text) => {
    let str = num_text || '';
    let new_text = str ? '+1' + str : '';
    return new_text;
  }

  getFormattedNumber = (num_str) => {
    let str        = num_str || '';
    let char_arr   = str.split('');
    let formatted  = '';
    let str_length = char_arr.length;

    let over_three = str_length > 3 && str_length < 7 ? true : false;
    let over_six   = str_length > 6 ? true : false;

    let digit_1  = str[0] || '';
    let digit_2  = str[1] || '';
    let digit_3  = str[2] || '';
    let digit_4  = str[3] || '';
    let digit_5  = str[4] || '';
    let digit_6  = str[5] || '';
    let digit_7  = str[6] || '';
    let digit_8  = str[7] || '';
    let digit_9  = str[8] || '';
    let digit_10 = str[9] || '';

    formatted = str;

    if (over_three) {
      formatted = '(' + digit_1 + digit_2 + digit_3 + ')' + ' - ' + digit_4 + digit_5 + digit_6;
    }

    if (over_six) {
      formatted = '(' + digit_1 + digit_2 + digit_3 + ')' + ' - ' + digit_4 + digit_5 + digit_6 + ' - ' + digit_7 + digit_8 + digit_9 + digit_10;
    }

    return formatted;
  }

  getNumbersOnly = (text) => {
    let cleaned_text = '';
    let input_text   = text || '';
    let chars_array  = input_text.split('');

    let allowed_chars = { '0': true, '1': true, '2': true, '3': true, '4': true, '5': true, '6': true, '7': true, '8': true, '9': true };

    chars_array.forEach((character) => {
      if (allowed_chars[character] && allowed_chars[character] === true && cleaned_text.length < 10) {
        cleaned_text = cleaned_text + character;
      }
    });

    return cleaned_text;
  }

  renderCountryDropdown = () => {

    let current_flag_code    = this.getIconAndCode();
    let current_code_element = <span className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: 'center' }}>
                                <span style={{ marginRight: 5 }}>{ current_flag_code.flag }</span>
                                <span style={{ fontSize: 14   }}>{ current_flag_code.code }</span>
                               </span>

    return <DropdownMenu className={ `country-code-dropdown` }
                         style={{  }}
                         toggle_element={ current_code_element }
                         menu_style={{ }}
                         menu_element={
                          <div className='flex-container-column country-menu-container' style={{  }}>
                            { this.getDropdownItems() }
                          </div>
                         }
                       />
  }

  getIconAndCode = () => {
    let country   = this.state.selected_country;
    let flag_code = this.getFlagCodeDict();

    return flag_code[country]
  }

  getDropdownItems = () => {
    let country   = this.state.selected_country;
    let flag_code = this.getFlagCodeDict();

    let items = Object.keys(flag_code).map((country_key) => {
      let flag_code_object = flag_code[country_key];
      let is_other_option  = country_key === 'other';
      if (flag_code_object && country_key !== country) {
        return <span className='flex-container-row country-menu-item'
                     key={country_key}
                     style={{ justifyContent: is_other_option ? 'center' : 'flex-start' }}
                     onClick={ () => {
                       this.setState({ ...this.state, selected_country: country_key })
                     }}>
                <span style={{ marginRight: is_other_option ? 0 : 5 }}>{ flag_code_object.flag }</span>
                <span style={{ fontSize: 13, color: 'grey' }}>{ flag_code_object.code }</span>
               </span>
      }
    }).filter((item) => { return item });

    return items;
  }

  getFlagCodeDict = () => {
    let flag_code = {};

    flag_code['united_states']  = { flag: <img src={ united_states_flag  } className='country-flag-icon' alt="Flag Icon" />, code: '+1' }
    // flag_code['canada']         = { flag: <img src={ canada_flag } className='country-flag-icon' alt="Flag Icon" />, code: '+1' }
    // flag_code['united_kingdom'] = { flag: <img src={ united_kingdom_flag } className='country-flag-icon' alt="Flag Icon" />, code: '+44' }
    // flag_code['mexico']         = { flag: <img src={ mexico_flag } className='country-flag-icon' alt="Flag Icon" />, code: '+52' }
    flag_code['other']          = { flag: <span></span>, code: 'Other' }

    return flag_code;
  }

}

export default PhoneInput
